import React from "react";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { GetUserProfileInformation } from "../../Api/Signin/Dashboard.Api";
import { sendCredentialVerfication } from "../../Api/Signin/Signin.Api";
import { MessageForm } from "../../Components/molecules/AuthForms/MessageForm";
import { FormItemsWrap } from "../../Components/molecules/Wrap/Wrap";
import { CallCenterAgent, SuperAdmin } from "../../Constants/AppContants";
import { useAuth } from "../../Store/AuthContext";
import useLoadingState from "../../Utils/Hooks/useLodingState";
import JwtDecoder from "../../Utils/JwtDecoder/JwtDecoder";

export const ResetPasswordSuccessMessage = () => {
  const { startLoading, stopLoading, LoadingState } = useLoadingState();
  const { t, i18n } = useTranslation(["glossary"]);
  //  Admin - Password reset already existing user
  const { state, dispatch } = useAuth();
  const location = useLocation();
  const locatioState = location.state;
  const navigate = useNavigate();

  const loadUserProfileInformation = async (email) => {
    try {
      const result = await GetUserProfileInformation(email);

      if (result.type == 0) {
        dispatch({ type: "SET_USER_NAME", payload: result.data });
      }
    } catch (ex) {}
  };
  const Login = async (e) => {
    try {
      startLoading({ btnName: "signin" });
      await sendCredentialVerfication({
        emailAddress: locatioState.message.username,
        password: locatioState.message.password,
      })
        .then((d) => {
          if (d.type === 0) {
            dispatch({ type: "SET_TOKEN_PAYLOAD", payload: d.data.token });
            dispatch({
              type: "SET_JWTDATA",
            });
            if (!state.lang.cookie) {
              dispatch({
                type: "SET_COOKIE",
              });
            }
            loadUserProfileInformation(locatioState.message.username);
            let role = JwtDecoder(d.data.token).roles;
            dispatch({ type: "SET_PERMISSION", payload: role });
            if (role === SuperAdmin) {
              navigate("/overview");
            } else if (role === CallCenterAgent) {
              navigate("/doctors");
            }
          } else if (d.message) {
          }
        })
        .catch((e) => console.log(e));
      stopLoading();
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Stack
      style={{
        padding: "42px 38px",
      }}
    >
      <FormItemsWrap
        gap={"32px"}
        width={"398px"}
        justifyContent={"space-around"}
      >
        <MessageForm
          messageLineOne={t("glossary:auth.reset-password.password-changed")}
          messageLineTwo={t("glossary:auth.reset-password.successfully")}
          buttonInputMessage={t("common:button.login")}
          onClick={Login}
          LoadingState={LoadingState}
        />
      </FormItemsWrap>
    </Stack>
  );
};
